import React, { Component } from 'react';
import { Grid, Row, Col, Radio, Button, ButtonToolbar, Checkbox } from 'react-bootstrap';

export class LineInformationDataIdentifier extends Component {
    constructor(props) {
        super(props);

        let defaultConfig = { showLineCode: false, showStops: false, showLineCodeUppercase: false, showStopsUppercase: false, showstopsOption: "none" };
        let parsedConfig = {};
        try {
            parsedConfig = props.configuration ? JSON.parse(props.configuration) : {};
        } catch (error) { }

        let config = Object.assign({}, defaultConfig, parsedConfig);

        let form = {
            id: props.selectedData || null,
            showLineCode: config.showLineCode,
            showLineCodeUppercase: config.showLineCodeUppercase,
            showStopsUppercase: config.showStopsUppercase,
            showStops: config.showStops,
            stopsOption: config.stopsOption
        };

        this.state = {
            selectedData: props.selectedData || null,
            form: form
        };
    }

    componentDidMount() {
        this.updateParent();
    }

    updateParent() {
        const { form } = this.state;

        const dataIdentifier = form.id || null;

        const configuration = JSON.stringify({
            showLineCode: form.showLineCode || false,
            showStops: form.showStops || false,
            showLineCodeUppercase: form.showLineCodeUppercase || false,
            showStopsUppercase: form.showStopsUppercase || false,
            stopsOption: form.showStops ? form.stopsOption : "none"
        });

        this.props.onSelectData(dataIdentifier);
        this.props.onConfigureData(configuration, false);
    }


    updateFormField(fieldName, value) {
        const form = this.state.form;
        const newForm = { ...form };
        newForm[fieldName] = value;

        this.setState({ form: newForm }, () => this.updateParent());
    }

    updateFormFieldWithLogic(fieldName, value) {
        const form = this.state.form;
        const newForm = { ...form };

        if (fieldName === "showStops") {
            newForm.showStops = value;
            newForm.stopsOption = value
                ? (form.stopsOption && form.stopsOption !== "none" ? form.stopsOption : "both")
                : "none";

            if (value) {
                newForm.showLineCode = false;
                newForm.id = null;
            }
        }
        else if (fieldName === "showLineCode") {
            newForm.showLineCode = value;
            newForm.id = value ? form.id : null;

            if (value) {
                newForm.showStops = false;
                newForm.stopsOption = "none";
            }
        }

        this.setState({ form: newForm }, () => this.updateParent());
    }


    handleLineCodeUppercaseChange = () => {
        this.updateFormField("showLineCodeUppercase", !this.state.form.showLineCodeUppercase);
    }
    
    handleStopsUppercaseChange = () => {
        this.updateFormField("showStopsUppercase", !this.state.form.showStopsUppercase);
    }

    handleLineCodeChange = (e) => {
        this.updateFormFieldWithLogic("showLineCode", e.target.checked);
    }

    handleShowStopsChange = (e) => {
        this.updateFormFieldWithLogic("showStops", e.target.checked);
    }

    handleStopsOptionChange = (option) => {
        this.updateFormField("stopsOption", option);
    }

    saveAndClose = () => {
        const { form } = this.state;

        const dataIdentifier = form.id || null;

        const configuration = JSON.stringify({
            showLineCode: form.showLineCode,
            showStops: form.showStops,
            showLineCodeUppercase: form.showLineCodeUppercase,
            showStopsUppercase: form.showStopsUppercase,
            stopsOption: form.showStops ? form.stopsOption : "none"
        });

        this.props.onSelectData(dataIdentifier);
        this.props.onConfigureData(configuration, true);
    }

    render() {
        const { form } = this.state;

        return (
            <div>
                <Grid fluid>
                    <Row>
                        <Col sm={12}>
                            <b>Dados a apresentar como identificador da linha:</b>
                        </Col>
                    </Row>

                    <Row style={{ display: "flex", flexDirection: "column", marginLeft: "40px", marginTop: "5px", marginBottom: "20px" }}>
                        <Row style={{ display: "flex" }}>
                            <Col style={{ width: "300px" }}>
                                <Checkbox
                                    checked={form.showLineCode}
                                    onChange={this.handleLineCodeChange}
                                    style={{ margin: 0, padding: 0 }}
                                >
                                    Código da Linha
                                </Checkbox>
                            </Col>
                            <Col>
                                <Checkbox
                                    checked={form.showLineCodeUppercase}
                                    onChange={this.handleLineCodeUppercaseChange}
                                    disabled={!form.showLineCode}
                                    style={{ margin: 0, padding: 0 }}
                                >
                                    Maíusculas
                                </Checkbox>
                            </Col>
                        </Row>

                        <Row style={{ display: "flex", alignItems: "center" }}>
                            <Col style={{ width: "300px" }}>
                                <Checkbox
                                    checked={form.showStops}
                                    onChange={this.handleShowStopsChange}
                                    style={{ margin: 0, padding: 0 }}
                                >
                                    Texto da Linha a apresentar:
                                </Checkbox>
                            </Col>
                            <Col>
                                <Checkbox
                                    checked={form.showStopsUppercase}
                                    onChange={this.handleStopsUppercaseChange}
                                    disabled={!form.showStops}
                                    style={{ margin: 0, padding: 0 }}
                                >
                                    Maíusculas
                                </Checkbox>
                            </Col>
                        </Row>

                        <Row style={{ display: "flex", alignItems: "flex-start", marginLeft: "20px" }}>
                            <Col style={{ width: "300px" }}>
                                <Radio
                                    name="stopsOption"
                                    disabled={!form.showStops}
                                    checked={form.stopsOption === "first"}
                                    onChange={() => this.handleStopsOptionChange("first")}
                                    style={{ margin: 0, padding: 0 }}
                                >
                                    Apenas Origem
                                </Radio>
                                <Radio
                                    name="stopsOption"
                                    disabled={!form.showStops}
                                    checked={form.stopsOption === "last"}
                                    onChange={() => this.handleStopsOptionChange("last")}
                                    style={{ margin: 0, padding: 0 }}
                                >
                                    Apenas Destino
                                </Radio>
                                <Radio
                                    name="stopsOption"
                                    disabled={!form.showStops}
                                    checked={form.stopsOption === "both"}
                                    onChange={() => this.handleStopsOptionChange("both")}
                                    style={{ margin: 0, padding: 0 }}
                                >
                                    Nome da Linha (Origem - Destino)
                                </Radio>
                                <Radio
                                    name="stopsOption"
                                    disabled={!form.showStops}
                                    checked={form.stopsOption === "headsign"}
                                    onChange={() => this.handleStopsOptionChange("headsign")}
                                    style={{ margin: 0, padding: 0 }}
                                >
                                    Headsign
                                </Radio>
                            </Col>
                        </Row>
                    </Row>
                </Grid>


                <ButtonToolbar>
                    <Button bsStyle="default" onClick={this.saveAndClose}>GUARDAR</Button>
                    <Button bsStyle="default" onClick={() => this.props.onCancel()}>FECHAR</Button>
                </ButtonToolbar>
            </div>
        );
    }
}